<template>
  <b-media tag="li">
    <template v-slot:aside>
      <span :style="adjustColor(resource.mediaType)" class="bg-gray pt-3 pl-3 media-wrapper">
        <font-awesome-icon class="text-white align-middle" :icon="adjustIcon(resource.mediaType)" size="2x"></font-awesome-icon>
      </span>
    </template>
    <h5 class="mt-0 mb-3 text-left">
      <router-link :to="{ name: 'resourceView', params: { id: resource.id }}">{{ resource.title }}</router-link>
    </h5>
    <p class="mb-0 text-left">
      <span class="text-justify">{{ resource.description }}</span>
    </p>
  </b-media>
</template>

<script>
export default {
  name: 'ResourceMedia',
  props: {
    resource: Object
  },
  methods: {
    adjustIcon (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'file-audio'
      } else if (mediaType === 'Video') {
        return 'play-circle'
      } else if (mediaType === 'Website') {
        return 'link'
      } else if (mediaType === 'Text') {
        return 'file-alt'
      } else if (mediaType === 'Pdf') {
        return 'file-pdf'
      } else {
        return 'file-alt'
      }
    },
    adjustColor (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'color: #f0d6f1'
      } else if (mediaType === 'Linked Video') {
        return 'color: #ff6c6c'
      } else if (mediaType === 'Website') {
        return 'color: #95c9ff'
      } else if (mediaType === 'Text') {
        return 'color: #fff37a'
      } else if (mediaType === 'Pdf') {
        return 'color: red'
      } else {
        return 'color: #fff37a'
      }
    }
  }
}
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceMedia.vue